import { render, staticRenderFns } from "./downloadCenter.vue?vue&type=template&id=401936e0&scoped=true&"
import script from "./downloadCenter.vue?vue&type=script&lang=js&"
export * from "./downloadCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401936e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('401936e0')) {
      api.createRecord('401936e0', component.options)
    } else {
      api.reload('401936e0', component.options)
    }
    module.hot.accept("./downloadCenter.vue?vue&type=template&id=401936e0&scoped=true&", function () {
      api.rerender('401936e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/dataManage/downloadCenter/downloadCenter.vue"
export default component.exports